


























import { Vue, Component, Prop } from "vue-property-decorator";
import { InputOption } from '@/store/template/types';
import {
  TemplateInput
} from "@/store/template/types";

@Component
export default class SelectOption extends Vue {
  store = this.$store.direct;

  @Prop() input!: TemplateInput;

  form: InputOption = {
    label: "",
    value: ""
  };

  get valid() {
    return (
      this.form.label &&
      this.form.label.length > 0 &&
      this.form.value &&
      this.form.value.length > 0
    );
  }

  save() {
    this.input.options.push(this.form);
    this.form = {
      value: "",
      label: ""
    };
  }
}
